import { $, $$ } from 'utils/dom';
import Swiperslider from 'modules/swiper/swiper';

const testimonials = $$('.testimonials');

if (testimonials.length) {
  testimonials.forEach(testimonial => {
    const slider = new Swiperslider(
      $('.testimonials__item-wrapper', testimonial),
      {
        container: testimonial,
        sliderOptions: {
          spaceBetween: 30,
          breakpoints: {
            // when window width is >= 768px
            768: {
              spaceBetween: 60,
            },
            1440: {
              spaceBetween: 100,
            },
          },
        },
      }
    );
    slider.init();
  });
}
